import React from 'react'
import cx from 'classnames'
import { CURRENT_AWARENESS, DASHBOARD, MW_ANALYTICS } from 'constants/controllers'
import hasSideWidth from 'helpers/hasSideWidth'
import LeftDrawerWrapperContainer from 'redux/containers/components/layout/LeftDrawerWrapperContainer'
import PopoverOverlay from './PopoverOverlay'
import Footer from './Footer'
import SmallFooter from './FooterSmall'
import usePage from 'hooks/usePage'

const Page = ({
  pageState,
  setPageView,
  pageId,
  toggleFullscreenOverlay,
  pageToggleOverlay,
  right,
  main,
  controller,
  headerHeight = 0,
  windowHeight = 0,
  deviceType,
  layoutName = 'default',
  pageToggleSide,
  browser,
  ...props
}) => {
  const maxHeight = deviceType.isMobile ? null : windowHeight - headerHeight || null
  const { display, overlay } = pageState
  const pageView = pageState.pageView || props.pageView || 'main'
  const page = usePage(setPageView, pageView, pageId, toggleFullscreenOverlay)
  const left = pageState.left || props.left
  const isDashboard = controller === DASHBOARD
  let footer
  if (main) {
    footer = isDashboard ? <Footer /> : <SmallFooter />
  }

  return (
    <div
      ref={page.containerRef}
      style={{ display }}
      onTouchStart={page.handleTouchStart}
      className={cx(
        {
          relative: true,
          [`layout-${layoutName}`]: true,
          [`view-${pageView}`]: true,
          'has-left': !!left,
          'has-right': !!right,
          'has-overlay': overlay !== null
        }
      )}
    >
      <Overlay {...{ overlay, pageToggleOverlay }} />
      <div
        className='w-100 overflow-y-auto bg-page-background scrolling-container'
        style={{ maxHeight }}
        onScroll={page.handleScroll}
        onClick={page.handleClick}
        id={pageId}
      >
        <div
          className={cx(
            'flex justify-center',
            { 'flex-wrap': controller !== MW_ANALYTICS }
          )}
        >
          {left && <Left {...{ left, pageView, browser, deviceType, props, controller }} />}
          <Main {...{ main, overlay, isDashboard, footer }} />
          {right && pageView === 'right' && <Right {...{ right, windowHeight, headerHeight, deviceType, browser }} />}
        </div>
        {isDashboard && <div className='vw-100'>{footer}</div>}
      </div>
      <a
        href={null}
        className='scrolling-container-overlay pointer'
        data-scroll-relay='.view-right .legislation-reference-body'
        onClick={() => pageToggleSide('main', true)}
      />
    </div>
  )
}

const Main = ({ main, overlay, isDashboard, footer }) => (
  <div className='grow-1 shrink-1 basis0 ph0 ma0 min-w0'>
    <PopoverOverlay props={overlay} />
    <div className='min-vh-100 mb8'>
      {main}
    </div>
    {!isDashboard && footer}
  </div>
)

const Overlay = ({ overlay, pageToggleOverlay }) => (
  <div component='div' className='overlay-wrapper'>
    {!overlay
      ? null
      : (
        <div
          className='overlay-container'
          onClick={() => !overlay.type.disableOutsideToggle && pageToggleOverlay(null)}
        >
          {overlay}
        </div>
        )}
  </div>
)

const Left = ({ left, pageView, browser, deviceType, props, controller }) => {
  const isCurrentAwareness = controller === CURRENT_AWARENESS
  const sideWidth = hasSideWidth({
    pageView,
    _pageView: props.pageView,
    deviceType,
    browser,
    controller,
    left
  })

  return (
    <>
      <LeftDrawerWrapperContainer {...{ pageView }}>
        {left}
      </LeftDrawerWrapperContainer>
      <div
        className={cx(
          'dn-m',
          { 'db dn-t': browser.isIE },
          { 'dn-l': !browser.isIE },
          { 'side-width': sideWidth },
          { 'dn ': pageView !== 'left' && (props.pageView === 'main' && deviceType.isMobile) },
          { 'dn ': isCurrentAwareness && props.pageView === 'main' }
        )}
      >
        {/* Empty for Spacing */}
      </div>
    </>
  )
}

const Right = ({ right, windowHeight, headerHeight, deviceType, browser }) => (
  <>
    <div
      className='sticky-l fixed-m absolute right0 top0 w15 ml0 mr2 ph6 shadow-black-1 overflow-y-auto bg-page-background max-w-100 z60'
      style={{
        height: windowHeight - headerHeight,
        top: deviceType.isMobile ? headerHeight : null
      }}
    >
      {right}
    </div>
    <div
      className={cx(
        'dn w15',
        { 'ie-side': browser.isIE && deviceType.isLargeDesktop }
      )}
    /> {/* Empty for Spacing */}
  </>
)

export default Page
